import { useState, type ReactNode } from 'react'
import { ArrowUpRight } from 'lucide-react'

import { Header } from '@/components/layout/header'
import { MobileNav } from '@/components/layout/mobile-nav'
import { Aurora } from '@/components/layout/aurora'
import { SearchSheet } from '@/components/search/search-sheet'
import { Toaster } from '@/components/ui/toast'
import { KagamiMark } from '@/components/brand/logo'

export function AppShell({ children }: { children: ReactNode }) {
  const [searchOpen, setSearchOpen] = useState(false)

  return (
    <div className="relative isolate flex min-h-dvh flex-col">
      <Aurora />
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[70] focus:rounded-lg focus:bg-primary focus:px-4 focus:py-2 focus:text-primary-foreground"
      >
        Skip to content
      </a>
      <Header />
      <main id="main" className="flex-1 pb-[calc(5.5rem+env(safe-area-inset-bottom))] pt-[calc(4.75rem+env(safe-area-inset-top))] sm:pt-[calc(5.25rem+env(safe-area-inset-top))] md:pb-10">
        {children}
      </main>
      <Footer />
      <MobileNav onSearch={() => setSearchOpen(true)} />
      <SearchSheet open={searchOpen} onOpenChange={setSearchOpen} />
      <Toaster />
    </div>
  )
}

const footerLinks = [
  { label: 'Hirax', href: 'https://ahri.cloud' },
  { label: 'Imprint', href: 'https://ahri.cloud/imprint' },
  { label: 'Privacy', href: 'https://ahri.cloud/privacy' },
  { label: 'Terms', href: 'https://ahri.cloud/terms' },
]

function Footer() {
  return (
    <footer className="hidden border-t md:block">
      <div className="mx-auto flex max-w-[110rem] items-center justify-between gap-4 px-6 py-6 text-sm text-muted-foreground">
        <span className="flex items-center gap-2">
          <KagamiMark className="size-5" />
          Kagami is part of Hirax
        </span>
        <nav className="flex gap-5">
          {footerLinks.map((l) => (
            <a key={l.href} href={l.href} className="inline-flex items-center gap-0.5 hover:text-foreground">
              {l.label}
              {l.label === 'Hirax' && <ArrowUpRight className="size-3.5" />}
            </a>
          ))}
        </nav>
      </div>
    </footer>
  )
}
